export default __webpack_public_path__ + "static/media/filterMenuIcon.2cfbbda9.svg";